import { Injectable, signal } from '@angular/core';

export interface ErrorContext {
  url: string;
  requestUrl?: string;
  error: {
    status: number;
    message: string;
  };
  timestamp: Date;
}

@Injectable({ providedIn: 'root' })
export class ErrorContextService {
  private errorContext = signal<ErrorContext | null>(null);

  saveContext(url: string, status: number, message: string, requestUrl?: string): void {
    this.errorContext.set({
      url,
      ...(requestUrl ? { requestUrl } : {}),
      error: { status, message },
      timestamp: new Date(),
    });
  }

  getContext(): ErrorContext | null {
    return this.errorContext();
  }

  clearContext(): void {
    this.errorContext.set(null);
  }

  getPreviousUrl(): string | null {
    return this.errorContext()?.url ?? null;
  }
}
